class CurrencyValueUIModel {
  constructor({
    currencyCode = undefined,
    base = 0,
    taxDetails = {},
    totalTax = 0,
    total = 0,
    totalCPPoints = 0,
    paymentCPPointsAux = false,
    reservationStatusAux = '',
    bookingFee = 0,
    totalWithoutBase = 0,
  } = {}) {
    this.currencyCode = currencyCode;
    this.base = base;
    this.totalTax = totalTax;
    this.total = total;
    this.taxDetails = taxDetails;
    this.taxDetailsRefundable = {};
    this.totalCPPoints = totalCPPoints;
    this.paymentCPPoints = paymentCPPointsAux;
    this.reservationStatus = reservationStatusAux;
    this.bookingFee = bookingFee;
    this.totalWithoutBase = totalWithoutBase;
  }

  getTotal() {
    return this.total;
  }

  getTotalPoints() {
    return this.totalCPPoints ? this.totalCPPoints : 0;
  }

  getTotalTax() {
    let totalTax = this.totalTax;

    if (totalTax === 0) {
      Object.keys(this.taxDetails).forEach(nameTax => {
        totalTax += this.taxDetails[nameTax];
      });
    }

    if (this.reservationStatus === 'ON_HOLD' && this.paymentCPPoints && this.taxDetails?.MXA) {
      totalTax = this.totalTax - this.taxDetails.MXA;
    }

    if (this.reservationStatus === 'ON_HOLD' && this.paymentCPPoints && this.taxDetails?.IVA) {
      totalTax = this.totalTax - this.taxDetails.IVA;
    }

    if (this.bookingFee > 0 && this.reservationStatus === '' && this.taxDetails?.Impuestos) {
      totalTax = this.totalTax - this.taxDetails.Impuestos;
    }

    return totalTax;
  }

  getTaxDetails() {
    return this.taxDetails;
  }

  /**
   * Returns pairs of tax code and value.
   * @return {[string, number][]} Return an array of pairs [taxCode, value], e.g. [["VAT", 10.99], ["OT", 1.50]]
   */
  getTaxDetailsAsList() {
    const taxDetailsList = [];

    if (this.taxDetails) {
      for (const code in this.taxDetails) {
        taxDetailsList.push([code, this.taxDetails[code]]);
      }
    }

    return taxDetailsList;
  }

  setTotalPoints(points) {
    return this.totalCPPoints = points;
  }

  toAPI() {
    return {
      '_meta':{
        class:'CurrencyValue',
      },
      base: this.base,
      currencyCode: this.currencyCode,
      totalTax: this.totalTax,
      total: this.total,
      taxDetails: this.taxDetails,
      totalCPPoints: this.totalCPPoints ? this.totalCPPoints : 0,
      taxDetailsRefundable: this.taxDetailsRefundable,
    };
  }
}

export default CurrencyValueUIModel;